const { Swiper } = require("swiper/bundle");

(function ($) {

  function initTestimonialThreeColumn() {
    if($(".fmp-testimonial__carousel-3-col")){
      var testimonialThreeColumn = new Swiper(
        ".fmp-testimonial__carousel-3-col",
        {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        }
      );
    }
  }

  initTestimonialThreeColumn();
  
  //Onload by category slug
  $( document ).ready(function() {
    if ( $(".page-template").hasClass("page-template-resume") && "" !== window.location.hash ) {
      var resumeTermId = $(location).prop('hash').substr(1);
      var selectTerm = "#fmp-" + resumeTermId;

      if ( $(selectTerm).length ){
        $(selectTerm).attr("checked", true);
        var resumeCategory = $(selectTerm).val();
        var resumeType = $(selectTerm).attr("data-service");

        if( "resume_childterm" !== resumeType ){
          $(".fmp-resume-subterm, .fmp-choose-service").removeClass(
            "fmp-content-loaded"
          );
        }

        fmpResumeWriting(resumeCategory, resumeType);
        $(".fmp-cart-block").addClass("fmp-hidden");
      }

      if( "gs-7-12" === resumeTermId || "gs-13-15" === resumeTermId || "ses" === resumeTermId ) {
        $("#fmp-federal-writing").attr("checked", true);
        fmpResumeWriting($( "#fmp-federal-writing" ).val(), "resume_childterm");
        
        setTimeout(function () {
          $(selectTerm).attr("checked", true);
          var resumeCategory = $(selectTerm).val();
          
          fmpResumeWriting(resumeCategory, "resume_sub_cat");
          $(".fmp-choose-service").removeClass("fmp-hidden");
          $(".fmp-cart-block").addClass("fmp-hidden");
        }, 1000);

      }

    }
  });

  //Resume Writing Category
  if ($(".fmp_service")) {
    $(".fmp_service").on("change", function (e) {
      e.preventDefault();
      $(".fmp-resume-subterm, .fmp-choose-service").removeClass(
        "fmp-content-loaded"
      );
      $(".fmp-resume-classification , .fmp-service-wrap").html(
        '<div class="fmp-content-preloader"><div class="preloader-spinner"></div></div>'
      );

      var resumeCategory = $(this).val();
      var resumeType = $(this).attr("data-service");

      var currentURL = window.location.toString();
      if (currentURL.indexOf("#") > 0) {
        currentURL = currentURL.substring(0, currentURL.indexOf("#"));
      }
      var resumeId  = $(this).attr("id");
      window.location = currentURL + '#' + resumeId.replace( 'fmp-', '');

      fmpResumeWriting(resumeCategory, resumeType);
      $(".fmp-cart-block").addClass("fmp-hidden");
    });
  }

  if ($(".fmp-resume")) {
    //Resume Writing Sub Category
    $(".fmp-resume").on("change", ".fmp_service_classification", function (e) {
      e.preventDefault();

      $(".fmp-resume-subterm, .fmp-choose-service").removeClass(
        "fmp-content-loaded"
      );
      $(".fmp-service-wrap").html(
        '<div class="fmp-content-preloader"><div class="preloader-spinner"></div></div>'
      );

      var currentURL = window.location.toString();
      if (currentURL.indexOf("#") > 0) {
        currentURL = currentURL.substring(0, currentURL.indexOf("#"));
      }
      var resumeId  = $(this).attr("id");
      window.location = currentURL + '#' + resumeId.replace( 'fmp-', '');

      var resumeSubCategory = $(this).val();
      fmpResumeWriting(resumeSubCategory, "resume_sub_cat");
      $(".fmp-choose-service").removeClass("fmp-hidden");
      $(".fmp-cart-block").addClass("fmp-hidden");
    });

    //Resume Writing Product
    $(".fmp-resume").on("click", ".fmp-choose-service__select-box", function (e) {
      e.preventDefault();
      // $(this).toggleClass("selected");

      var inputQuantity = $(this).find( "input[name=fmp-quantity]" );
      if( 0 < inputQuantity.length ) {
        inputQuantity.val( 0 == inputQuantity.val() ? 1 : 0 );
        
        if ( 0 == inputQuantity.val() ) {
          $(this).removeClass("selected");
        } else {
          $(this).addClass("selected");
        }
      } else {
        var product = $(this).find( "input[name=fmp-product]" );
        product.prop("checked", !product.prop("checked"));
      }

      var resumeDiscount = $(this)
        .closest(".fmp-resume-service ")
        .attr("data-resume");

      if ("fmp-product-discount" === resumeDiscount) {
        $(".fmp-choose-additional-services")
          .find(".regular-price")
          .removeClass("fmp-strike");
        $(".fmp-choose-additional-services")
          .find(".discount-price")
          .addClass("fmp-hidden");
      }

      var discountPrices = $(".fmp-choose-additional-services li");
      if (
        "fmp-product-discount" === resumeDiscount &&
        $(this).find( "input[name=fmp-product]" ).prop("checked")
      ) {
        $(discountPrices).each(function (i, element) {
          var value = $(element).find(".discount-price").text();
          if (value.length > 1) {
            $(element).find(".regular-price").addClass("fmp-strike");
            $(element).find(".discount-price").removeClass("fmp-hidden");
          }
        });
      }
      fmpAddResume();
    });

    $(".fmp-resume").on("keyup", "input[name=fmp-quantity]", function () {
      var input = parseInt($(this).val());
      var inputMax = parseInt($(this).attr("max"));
      if (input == 0) {
        $(this)
          .closest(".fmp-choose-service__select-box")
          .removeClass("selected");
        fmpAddResume();
      }

      if (!inputMax || input > inputMax) {
        alert("The maximum quantity is " + inputMax + " of this service.");
        $(this).val(inputMax);
        fmpAddResume();
      }
      if (input > 0 && input <= inputMax) {
        $(this).closest(".fmp-choose-service__select-box").addClass("selected");
        fmpAddResume();
      }
    });
    $(".fmp-resume").on("click", "input[name=fmp-quantity]", function () {
      var input = parseInt($(this).val());
      if (input == 0) {
        $(this).val("");
      }
    });
    $(".fmp-resume").on("focusout", "input[name=fmp-quantity]", function () {
      var input = parseInt($(this).val());
      if (isNaN(input)) {
        $(this)
          .closest(".fmp-choose-service__select-box")
          .removeClass("selected");
        $(this).val(0);
        fmpAddResume();
      }
    });

    $(".fmp-resume").on("click", ".input-number-increment", function (e) {
      e.stopPropagation();
      var max = $(this)
        .closest(".fmp-choose-service__select__quantity")
        .find(".input-number")
        .attr("max");
      var value = $(this)
        .closest(".fmp-choose-service__select__quantity")
        .find(".input-number")
        .val();
      value++;
      if (!max || value <= max) {
        $(this)
          .parent(".fmp-choose-service__select__quantity")
          .find(".input-number")
          .val(value);
      }

      if (value > 0) {
        $(this).closest(".fmp-choose-service__select-box").addClass("selected");
        fmpAddResume();
      }
    });

    $(".fmp-resume").on("click", ".input-number-decrement", function (e) {
      e.stopPropagation();
      var min = $(this)
        .parent(".fmp-choose-service__select__quantity")
        .find(".input-number")
        .attr("min");
      var value = $(this)
        .parent(".fmp-choose-service__select__quantity")
        .find(".input-number")
        .val();
      value--;
      if (!min || value >= min) {
        $(this)
          .parent(".fmp-choose-service__select__quantity")
          .find(".input-number")
          .val(value);

        fmpAddResume();
      }

      if (value < 1) {
        $(this)
          .closest(".fmp-choose-service__select-box")
          .removeClass("selected");
      }
    });

    function fmpAddResume() {
      var selectedResumes = [];
      var parentResume = $(
        '.fmp-resume-post li[data-resume="fmp-product-discount"]'
      ).attr("data-id");
      $("input:checkbox[name=fmp-product]:checked").each(function () {
        var value = $(this).val();
        data = { id: value, quantity: "1" };
        selectedResumes.push(data);
      });

      $("input[name=fmp-quantity]").each(function () {
        var quantity = parseInt($(this).val());
        if (quantity > 0) {
          var productID = $(this)
            .closest(".fmp-choose-service__select")
            .find("input[name=fmp-product]")
            .val();
          data = { id: productID, quantity: quantity };
          selectedResumes.push(data);
        }
      });

      if (selectedResumes.length === 0) {
        $(".fmp-cart-block").addClass("fmp-hidden");
      } else {
        // sessionStorage.setItem("fmp_add_product", JSON.stringify(selectedResumes));
        $(".fmp-cart-block").removeClass("fmp-hidden");
        $(".fmp-cart-block .fmp-cart-detail").html(
          '<div class="fmp-content-preloader"><div class="preloader-spinner"></div></div>'
        );
        var data = {
          action: "fmp_add_resumes",
          nounce: localized.ajaxnonce,
          selected_resume: selectedResumes,
          parent_resume: parentResume,
        };
        $.ajax({
          type: "POST",
          dataType: "json",
          url: localized.ajaxurl,
          data: data,
          success: function success(response) {
            sessionStorage.setItem(
              "fmp_add_product",
              JSON.stringify(response.products)
            );
            $(".fmp-cart-block .fmp-cart-detail").html(response.output);
          },
        });
      }
    }

    //Resume Writing Product Remove
    $(".fmp-resume").on("click", ".fmp-resume-remove", function (e) {
      e.preventDefault();

      var dataId = $(this).parent(".fmp-resume-item").attr("data-id");

      $(".fmp-" + dataId)
        .find("input")
        .prop("checked", false);
      $(".fmp-" + dataId)
        .find(".fmp-choose-service__select-box")
        .removeClass("selected");

      $(".fmp-" + dataId)
        .find("input[name=fmp-quantity]")
        .val(0);

      if ("fmp-product-discount" === $(".fmp-" + dataId).attr("data-resume")) {
        $(".fmp-choose-additional-services")
          .find(".regular-price")
          .removeClass("fmp-strike");
        $(".fmp-choose-additional-services")
          .find(".discount-price")
          .addClass("fmp-hidden");
      }
      var parentResume = $(
        '.fmp-resume-post li[data-resume="fmp-product-discount"]'
      ).attr("data-id");

      var addProduct = JSON.parse(sessionStorage.getItem("fmp_add_product"));
      addProduct = addProduct.filter(function (el) {
        return dataId.indexOf(el.id) < 0;
      });
      sessionStorage.setItem("fmp_add_product", JSON.stringify(addProduct));

      if (addProduct.length == 0) {
        if ($("#primary").hasClass("fmp-create-account__main")) {
          window.location.href = window.location.origin;
        }
      }

      var data = {
        action: "fmp_remove_resumes",
        nounce: localized.ajaxnonce,
        remove_product: dataId,
        add_product: addProduct,
        parent_resume: parentResume,
      };

      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          var detail = response.detail;
          var total = response.total;

          if (detail) {
            detail.forEach((e) => {
              var discount = '';
              if( null != e.before_discount ){
                discount = e.before_discount;
              }
              $('li[data-id="' + e.product_id + '"]')
                .find(".fmp-item-price")
                .html(discount + response.currentSymbol + e.price);
            });
          }
          if( null != response.total_before ){
            $(".fmp-total-before").html( response.currentSymbol + response.total_before );
            $(".fmp-total-saved b").html( response.currentSymbol + response.total_saved );
          }else{
            $(".fmp-total-before").remove();
            $(".fmp-saved").remove();
          }

          $(".fmp-cart-block__total .fmp-total-price").html(
            response.currentSymbol + total
          );
          $(".fmp-afterpay .fmp-total-price").html(
            response.currentSymbol + response.afterpay
          );
          $(".fmp-resume-total span").html(
            "Proceed to Checkout (" + response.currentSymbol + total + ")"
          );
        },
      });

      if ($(".fmp-cart-block__items .fmp-resume-item").length == 1) {
        $(".fmp-cart-block").addClass("fmp-hidden");
      }

      $(".fmp-cart-block__items")
        .find("[data-id='" + dataId + "']")
        .removeClass("fmp-resume-item")
        .fadeOut(300);
    });

    // Resume page redirect to checkout
    $(".fmp-resume").on("click", ".fmp-resume-total", function (e) {
      e.preventDefault();
      var products = JSON.parse(sessionStorage.getItem("fmp_add_product"));
      var parentResume = $(
        '.fmp-resume-post li[data-resume="fmp-product-discount"]'
      ).attr("data-id");
      fmpResumeAddToCart(products, parentResume);
    });
  }
  

  function fmpResumeWriting(resumeCategory, resumeType) {
    var pageId = $(".fmp-resume").attr("page-id");
    var data = {
      action: "fmp_resume_category",
      nounce: localized.ajaxnonce,
      resume_category: resumeCategory,
      resume_type: resumeType,
      page_id: pageId,
    };

    if ("resume_childterm" == resumeType) {
      $(".fmp-resume-subterm").removeClass("fmp-hidden");
      $(".fmp-resume-subterm").removeClass("fmp-hidden");
      $(".fmp-choose-service").addClass("fmp-hidden");
      $(".fmp-info").addClass("fmp-hidden");
      $(".footer-links").addClass("fmp-hidden");
      $("html, body").animate(
        {
          scrollTop: $("#fmp-gs-classification").offset().top,
        },
        1000
      );
    } else {
      $(".fmp-choose-service").removeClass("fmp-hidden");
      $(".fmp-resume-subterm").addClass("fmp-hidden");
      $("html, body").animate(
        {
          scrollTop: $("#fmp-professional-services").offset().top,
        },
        1000
      );
      $(".fmp-info").removeClass("fmp-hidden");
      $(".footer-links").removeClass("fmp-hidden");
    }

    if ("resume_sub_cat" == resumeType) {
      $(".fmp-resume-subterm").removeClass("fmp-hidden");
      $("html, body").animate(
        {
          scrollTop: $("#fmp-professional-services").offset().top,
        },
        1000
      );
    }

    $.ajax({
      type: "POST",
      dataType: "json",
      url: localized.ajaxurl,
      data: data,
      success: function success(response) {
        $(".fmp-resume-subterm, .fmp-choose-service, .fmp-info").addClass(
          "fmp-content-loaded"
        );

        if (true === response.hasChild) {
          $(".fmp-resume-classification").html(response.output);
        } else {
          $(".fmp-service-wrap").html(response.output);
        }

        if( response.review ){
          if( response.review['review_name'] ){
            $(".fmp-reviews__testimonial-user-name").html(response.review['review_name']);
          }
          if( response.review['review_position'] ){
            $(".fmp-reviews__testimonial-user-title").html(response.review['review_position']);
          }
          if( response.review['review_content'] ){
            $(".fmp-reviews__testimonial-content").html(response.review['review_content']);
          }
        }

      },
    });
  }

  function fmpResumeAddToCart(products, parentResume) {
    $.ajax({
      url: localized.ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "fmp_resume_add_to_cart",
        items: products,
        parent_resume: parentResume,
        nounce: localized.ajaxnonce,
      },
      success: function (response) {
        sessionStorage.removeItem("fmp_user_detail");
        sessionStorage.removeItem("fmp_user");
        var redirect = $(".fmp-resume-total").attr("href");
        window.location.href = redirect;
      },
    });
  }

})(jQuery);
